// Role'e gore admin veya kullanici layout'u secen wrapper.
// Hem admin hem normal kullanicinin erisebildigi (ama farkli layout gormesi
// gereken) sayfalarda kullanilir. Ornek: /vehicles, /vehicles/:id.
import React from "react";
import DashboardLayout from "./DashboardLayout";
import AdminDashboardLayout from "./AdminDashboardLayout";
import { useAuth } from "../contexts/AuthContext";
import { isPrivileged } from "../utils/roles";

const RoleAwareLayout = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) return <div style={{ padding: 16 }}>Yükleniyor...</div>;

  const Layout = isPrivileged(user) ? AdminDashboardLayout : DashboardLayout;
  return <Layout>{children}</Layout>;
};

export default RoleAwareLayout;
